export const endorsements_photos = {
  block: 'endorsements_three_columns_images_inside',
  args: {},
};
